import L from "leaflet";

const StripePatternClass = (L as any).Pattern.extend({
  options: {
    width: 24,
    height: 24,
    // Rotate the whole tile. Use 45 for diagonal stripes.
    angle: 0,
    // Stripe appearance
    weight: 2,
    color: "#000000",
    opacity: 1,
    dashArray: null,
    // Background
    backgroundFillColor: "#ffffff",
    backgroundFillOpacity: 1,
    // Stripe layout
    stripeCount: 1, // 1 or 2
    stripeGap: 8, // distance between double stripes
  },

  _addShapes: function () {
    this._background = new (L as any).PatternPath({
      fill: true,
      stroke: false,
      fillColor: this.options.backgroundFillColor,
      fillOpacity: this.options.backgroundFillOpacity,
    });

    this._stripe1 = new (L as any).PatternPath({
      stroke: true,
      fill: false,
      weight: this.options.weight,
      color: this.options.color,
      opacity: this.options.opacity,
      dashArray: this.options.dashArray,
    });

    this.addShape(this._background);
    this.addShape(this._stripe1);

    if (this.options.stripeCount === 2) {
      this._stripe2 = new (L as any).PatternPath({
        stroke: true,
        fill: false,
        weight: this.options.weight,
        color: this.options.color,
        opacity: this.options.opacity,
        dashArray: this.options.dashArray,
      });

      this.addShape(this._stripe2);
    }

    this._update();
  },

  _update: function () {
    const w = this.options.width;
    const h = this.options.height;
    const centerY = h / 2;

    this._background.options.d = `M 0 0 H ${w} V ${h} H 0 Z`;

    if (this._stripe2) {
      const halfGap = this.options.stripeGap / 2;
      this._stripe1.options.d = `M 0 ${centerY - halfGap} H ${w}`;
      this._stripe2.options.d = `M 0 ${centerY + halfGap} H ${w}`;
    } else {
      this._stripe1.options.d = `M 0 ${centerY} H ${w}`;
    }
  },

  setStyle: (L as any).Pattern.prototype.setStyle,
});

export default function StripePattern(options: any) {
  return new StripePatternClass(options);
}
// import L from "leaflet";

// const StripePatternClass = (L as any).Pattern.extend({
//   options: {
//     width: 24,
//     height: 24,
//     orientation: "diagonal",
//     weight: 3,
//     color: "#000000",
//     opacity: 1,
//     dashArray: null,

//     backgroundFillColor: "#ffffff",
//     backgroundFillOpacity: 1,

//     stripeCount: 1,
//     stripeGap: 8,
//   },

//   _addShapes: function () {
//     this._background = new L.PatternPath({
//       fill: true,
//       stroke: false,
//       fillColor: this.options.backgroundFillColor,
//       fillOpacity: this.options.backgroundFillOpacity,
//     });

//     this._stripe1 = new L.PatternPath({
//       stroke: true,
//       weight: this.options.weight,
//       color: this.options.color,
//       opacity: this.options.opacity,
//       dashArray: this.options.dashArray,
//     });

//     this.addShape(this._background);
//     this.addShape(this._stripe1);

//     if (this.options.stripeCount === 2) {
//       this._stripe2 = new L.PatternPath({
//         stroke: true,
//         weight: this.options.weight,
//         color: this.options.color,
//         opacity: this.options.opacity,
//         dashArray: this.options.dashArray,
//       });
//       this.addShape(this._stripe2);
//     }

//     this._update();
//   },

//   _getPath: function (offset = 0) {
//     const w = this.options.width;
//     const h = this.options.height;
//     const half = this.options.weight / 2 + offset;

//     switch (this.options.orientation) {
//       case "horizontal":
//         return `M 0 ${h / 2 + offset} H ${w}`;
//       case "vertical":
//         return `M ${w / 2 + offset} 0 V ${h}`;
//       case "diagonal":
//       default:
//         return `M ${-w / 2} ${h / 2 + offset} L ${w + w / 2} ${h / 2 - w + offset}`;
//     }
//   },

//   _update: function () {
//     const w = this.options.width;
//     const h = this.options.height;
//     this._background.options.d = `M 0 0 H ${w} V ${h} H 0 Z`;

//     this._stripe1.options.d = this._getPath(0);

//     if (this._stripe2) {
//       this._stripe2.options.d = this._getPath(this.options.stripeGap);
//     }
//   },

//   setStyle: L.Pattern.prototype.setStyle,
// });

// export default function StripePattern(options: any) {
//   return new StripePatternClass(options);
// }
